import {defineStore} from 'pinia'
import axios from '@/api/axios'

export const useAdAccountTopUpRequestStore = defineStore({
  id: 'adAccountTopUpRequest',
  actions: {
    async createAdAccountTopUpRequest(payload) {
      const {data} = await axios.post('ad-account-top-up-requests', {ad_accounts: payload})

      return data
    },

    async createAdAccountTransferRequest(payload) {
      const {data} = await axios.post('/v1/ad-account-top-up-requests/transfer', payload)

      return data
    },

    async getAdAccountTopUpRequests(params = {}) {
      const {data} = await axios.get('ad-account-top-up-requests', {params})

      return data
    },

    async getAdAccountTopUpRequestSummary(params = {}) {
      const {data} = await axios.get('/ad-account-top-up-requests/top-up-summary', {params})

      return data
    },
  },
})
